<template>
	<Card>
		<form class="submit-form" @submit.prevent="submit">
			<!-- Nickname -->
			<FieldInput
				name="nickname"
				label="Display name"
				placeholder="Anonymous"
				v-model="fields.nickname"
				:errors="errors.nickname"
			/>
			<!-- Student number -->
			<FieldInput
				name="studentNumber"
				label="Student number"
				v-model="fields.studentNumber"
				:errors="errors.studentNumber"
			/>
			<!-- Title field for text submissions -->
			<FieldTextarea
				v-if="isText"
				required
				name="title"
				label="Submission title"
				v-model="fields.title"
				:errors="errors.title"
			/>
			<!-- Image upload -->
			<FieldUpload
				v-if="isImage"
				required
				name="image"
				label="Submission photo"
				:info="`PNG, JPG or GIF files up to ${sizeLimit} accepted`"
				v-model="fields.image"
				:errors="errors.image"
			/>
			<!-- Drawing canvas -->
			<Paint
				v-if="isDrawing"
				required
				name="drawing"
				label="Submission drawing"
				v-model="fields.drawing"
				:errors="errors.drawing"
			/>
			<!-- Title field for non-text submissions -->
			<FieldInput
				v-if="!isText"
				required
				name="title"
				label="Submission name"
				v-model="fields.title"
				:errors="errors.title"
			/>
			<!-- Submit -->
			<div>
				<SubmitButton
					class="btn btn--submit"
					label="Submit"
					v-bind="submitButton"
				/>
				<input
					type="button"
					class="btn btn--cancel"
					value="Cancel"
					@click="cancel"
				/>
			</div>
		</form>
	</Card>
</template>

<script>
import { enums, lib } from 'protoswipe-shared'
import Paint from '@/components/main/Paint'
import Card from '@/components/shared/Card'
import FieldInput from '@/components/shared/FieldInput'
import SubmitButton from '@/components/shared/SubmitButton'
import FieldTextarea from '@/components/shared/FieldTextarea'
import FieldUpload from '@/components/shared/FieldUpload'
import form from '@/mixins/form'

const { CampaignType } = enums
const { toBytes, SIZE_LIMIT } = lib.file

export default {
	name: 'AdminSubmissionForm',
	props: {
		campaign: Object
	},
	data() {
		return {
			sizeLimit: toBytes(SIZE_LIMIT)
		}
	},
	computed: {
		isText() {
			return this.campaign.type === CampaignType.text
		},
		isImage() {
			return this.campaign.type === CampaignType.image
		},
		isDrawing() {
			return this.campaign.type === CampaignType.drawing
		}
	},
	methods: {
		init() {
			// Populate form with campaign details
			this.form.reset()
			this.form.populate({
				campaignId: this.campaign.id,
				type: this.campaign.type
			})
		}
	},
	created() {
		this.init()
	},
	mixins: [form.adminSubmission],
	components: {
		Paint,
		Card,
		FieldInput,
		SubmitButton,
		FieldTextarea,
		FieldUpload
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.submit-form {
	max-width: 640px;
}

.submit-form > :not(:last-child) {
	margin-bottom: 2rem;
}

.btn {
	width: 100%;

	&--cancel {
		@include button--large($black, transparent, $black, $grey-90);
	}

	& + & {
		margin: 1rem 0 0 0;
	}

	@include mq(md) {
		width: auto;
		& + & {
			margin: 0 0 0 1rem;
		}
	}
}
</style>
